(ns nosco.ui.dropzone
  (:require
   ["react" :as React]
   ["react-dropzone" :refer [useDropzone]]
   [hx.react :refer [defnc]]
   [nosco.i18n.translate :as t]
   [nosco.icons]
   [nosco.ui.buttons]
   [nosco.ui.buttons2 :as buttons2]))

;; implementing this with plain react because hx
;; doesn't like a js map as props; perhaps though
;; we should add this to the hx parsing mechanism?
(defn DropzoneImpl [^js props]
  (let [dropzone (.-dropzone props)
        children (.-children props)]
    (React/createElement "div" (.getRootProps dropzone #js {:className (.-class props) :style (.-style props)})
                         (React/createElement "input" (.getInputProps dropzone))
                         children)))

(defn use-dropzone
  "Convenience wrapper over useDropzone that deals with common arguments.
  For more options either extend this or use useDropzone directly."
  [{:keys [on-drop accept max-files no-click disabled]}]
  (let [props (cond-> {:onDrop on-drop}
                accept (assoc :accept accept)
                disabled (assoc :disabled disabled)
                no-click (assoc :noClick no-click)
                max-files (assoc :maxFiles max-files))]
    (useDropzone (clj->js props))))

(defn drag-active? [^js dropzone]
  (.-isDragActive dropzone))

(defnc Dropzone [{:keys [on-drop accept max-files button-label text active width height style]}]
  (let [dropzone (use-dropzone {:on-drop on-drop
                                :accept accept
                                :max-files max-files})
        active? (or active (drag-active? dropzone))
        button-label (or button-label
                         (t/tp ["Add file"
                                "Add files"]
                               (or max-files 1)))
        text (or text
                 (t/tp ["or drop file to upload"
                        "or drop files to upload"]
                       (or max-files 1)))]
    [DropzoneImpl {:dropzone dropzone
                   :class (if active?
                            "nosco-dropzone nosco-dropzone--active"
                            "nosco-dropzone")
                   :style (or style {:height (or height 230) :max-width (or width 544)})}
     [nosco.icons/Icon {:icon "icon-import"
                        :class "nosco-icon--xl text-gray-500 mb-spacing-16"}]
     [buttons2/Button {:variant :secondary
                       :label button-label}]
     [:div {:class "mt-spacing-16 text-gray-700 nosco-dropzone__label"}
      text]]))
